// extracted by mini-css-extract-plugin
export default {"title":"_9f8ff738","bar":"_32d83409"};